var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMerryGoRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.333,
    x2: 262.349,
    xlinkHref: "#lg1",
    y1: 232.56,
    y2: 232.56
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(0 1 -1 0 2083.56 1573.56)",
    gradientUnits: "userSpaceOnUse",
    x1: -1347.667,
    x2: -1333.651,
    xlinkHref: "#lg1",
    y1: 1828.56,
    y2: 1828.56
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(.707 .707 -.707 .707 1367.675 355.261)",
    gradientUnits: "userSpaceOnUse",
    x1: -880.21,
    x2: -866.194,
    xlinkHref: "#lg1",
    y1: 700.018,
    y2: 700.018
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 1728.299 2941.235)",
    gradientUnits: "userSpaceOnUse",
    x1: -880.21,
    x2: -866.194,
    xlinkHref: "#lg1",
    y1: 2957.102,
    y2: 2957.102
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.973,
    x2: 405.709,
    xlinkHref: "#lg2",
    y1: 82.533,
    y2: 383.27
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.782,
    x2: 2.852,
    xlinkHref: "#lg2",
    y1: 398.342,
    y2: -19.588
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e5959",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.928,
    x2: 90.322,
    xlinkHref: "#lg3",
    y1: 232.582,
    y2: 184.244
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.6,
    x2: 334.375,
    xlinkHref: "#lg3",
    y1: 355.494,
    y2: 368.921
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.418,
    x2: 150.649,
    xlinkHref: "#lg3",
    y1: 423.305,
    y2: 363.669
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 450.282,
    x2: 424.502,
    xlinkHref: "#lg3",
    y1: 230.369,
    y2: 176.928
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.492,
    x2: 290.241,
    xlinkHref: "#lg3",
    y1: 75.48,
    y2: 62.948
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.715,
    x2: 279.223,
    y1: 30.424,
    y2: 77.932
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9b1ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#af66da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6764,
    stopColor: "#a660cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8297,
    stopColor: "#8d51b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#6f3f8a"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 68.666,
    y2: 100.975
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6f3f8a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6f3f8a"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.715,
    x2: 279.223,
    xlinkHref: "#lg4",
    y1: 388.126,
    y2: 435.634
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg5",
    y1: 426.368,
    y2: 458.677
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(1 -.001 .001 1 140.803 79.134)",
    gradientUnits: "userSpaceOnUse",
    x1: 243.046,
    x2: 290.555,
    y1: 36.289,
    y2: 83.797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(1 -.001 .001 1 140.803 79.134)",
    gradientUnits: "userSpaceOnUse",
    x1: 266.332,
    x2: 266.332,
    y1: 74.531,
    y2: 106.841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(1 -.013 .013 1 -167.327 -75.593)",
    gradientUnits: "userSpaceOnUse",
    x1: 241.734,
    x2: 289.242,
    y1: 382.262,
    y2: 429.77
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ade194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68ca44"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(1 -.013 .013 1 -167.327 -75.593)",
    gradientUnits: "userSpaceOnUse",
    x1: 265.019,
    x2: 265.019,
    y1: 420.504,
    y2: 452.814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#017b4e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6867,
    stopColor: "#016f46",
    stopOpacity: 0.687
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(1 -.017 .017 1 -170.542 83.63)",
    gradientUnits: "userSpaceOnUse",
    x1: 249.108,
    x2: 296.616,
    xlinkHref: "#lg4",
    y1: 36.343,
    y2: 83.852
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(1 -.017 .017 1 -170.542 83.63)",
    gradientUnits: "userSpaceOnUse",
    x1: 272.393,
    x2: 272.393,
    xlinkHref: "#lg5",
    y1: 74.586,
    y2: 106.895
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(1 -.03 .03 1 80.612 -70.346)",
    gradientUnits: "userSpaceOnUse",
    x1: 291.085,
    x2: 338.594,
    y1: 383.325,
    y2: 430.833
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#62dbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08a9f1"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(1 -.03 .03 1 80.612 -70.346)",
    gradientUnits: "userSpaceOnUse",
    x1: 314.371,
    x2: 314.371,
    y1: 421.567,
    y2: 453.876
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#017bae",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6303,
    stopColor: "#02678e",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025f80"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.495,
    x2: 335.884,
    xlinkHref: "#lg4",
    y1: 320.563,
    y2: 320.563
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg5",
    y1: 381,
    y2: 449.029
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.147,
    x2: 248.532,
    xlinkHref: "#lg5",
    y1: 375.853,
    y2: 225.237
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(0 1 1 0 -1407.242 1407.242)",
    gradientUnits: "userSpaceOnUse",
    x1: -972.745,
    x2: -897.242,
    xlinkHref: "#lg2",
    y1: 1662.242,
    y2: 1662.242
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 473.333,
    y2: 508.058
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.76,
    x2: 294.799,
    xlinkHref: "#lg2",
    y1: 180.26,
    y2: 256.299
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientTransform: "matrix(-1 0 0 -1 510 3625)",
    gradientUnits: "userSpaceOnUse",
    x1: 236.233,
    x2: 275.61,
    xlinkHref: "#lg2",
    y1: 3389.733,
    y2: 3429.11
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m247.5 53.893h15v357.333h-15z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.333 225.06h357.333v15h-357.333z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m133.967 364.2-10.607-10.607 252.673-252.673 10.607 10.607z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.36 111.527 10.607-10.607 252.673 252.673-10.607 10.607z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m457.483 232.56c0 111.65-90.833 202.483-202.483 202.483s-202.483-90.833-202.483-202.483 90.833-202.483 202.483-202.483 202.483 90.833 202.483 202.483zm-48.338 0c0-84.996-69.149-154.145-154.145-154.145s-154.145 69.149-154.145 154.145 69.149 154.145 154.145 154.145 154.145-69.15 154.145-154.145z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 53.709c-98.619 0-178.851 80.232-178.851 178.851s80.232 178.851 178.851 178.851 178.851-80.232 178.851-178.851-80.232-178.851-178.851-178.851zm0 332.996c-84.996 0-154.145-69.149-154.145-154.145s69.149-154.145 154.145-154.145 154.145 69.149 154.145 154.145-69.15 154.145-154.145 154.145z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.023 213.587c1.676-13.589 5.13-26.633 10.117-38.899h-49.016z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.792 293.006c-17.955 41.958-54.008 74.389-98.287 87.438v49.878c37.775-8.303 71.626-27.18 98.287-53.365z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.81 429.722v-50.09c-30.025-9.45-56.116-27.857-75.123-52.077l-34.349 34.349c27.725 33.311 65.913 57.616 109.472 67.818z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.802 192.306 53.252 53.252c.274-4.3.429-8.631.429-12.998 0-27.532-5.533-53.793-15.529-77.744h-53.898c6.813 11.617 12.147 24.2 15.746 37.49z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.667 78.727c32.582 2.027 62.452 14.217 86.471 33.437v-57.769c-25.951-14.059-55.3-22.609-86.471-24.082z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 53.709,
    fill: "url(#SVGID_12_)",
    r: 53.709
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.409 57.108c1.755 28.077 25.071 50.31 53.591 50.31s51.835-22.232 53.591-50.31z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 411.411,
    fill: "url(#SVGID_14_)",
    r: 53.709
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.409 414.81c1.755 28.077 25.071 50.31 53.591 50.31s51.835-22.232 53.591-50.31z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 407.164,
    cy: 138.573,
    fill: "url(#SVGID_16_)",
    r: 53.709
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.575 141.999c1.77 28.076 25.097 50.297 53.616 50.282s51.824-22.259 53.565-50.337z",
    fill: "url(#SVGID_17_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 102.835,
    cy: 326.547,
    fill: "url(#SVGID_18_)",
    r: 53.709
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.292 330.629c2.113 28.053 25.71 49.986 54.227 49.623s51.548-22.891 52.946-50.988z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 102.835,
    cy: 138.573,
    fill: "url(#SVGID_20_)",
    r: 53.709
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.311 142.892c2.237 28.043 25.931 49.872 54.447 49.382s51.446-23.119 52.719-51.222z",
    fill: "url(#SVGID_21_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 407.164,
    cy: 326.547,
    fill: "url(#SVGID_22_)",
    r: 53.709
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.701 331.569c2.606 28.011 26.585 49.527 55.091 48.662 28.507-.865 51.138-23.794 52.041-51.911z",
    fill: "url(#SVGID_23_)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m211.801 228.607-57.801 213.561 14.971 4.631c56.9 17.601 115.158 17.601 172.058 0l14.971-4.631-57.801-213.561c-17.135-63.309-69.263-63.309-86.398 0z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154 442.168 14.971 4.631c56.9 17.601 115.158 17.601 172.058 0l14.971-4.631-23.863-88.168h-154.274z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.199 228.607c-16.716-61.762-66.73-63.26-85.074-4.516v29.346l125.858 125.858z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m510 491.919v-39.341c0-9.986-8.095-18.081-18.081-18.081h-473.838c-9.986 0-18.081 8.095-18.081 18.081v39.341c0 9.986 8.095 18.081 18.081 18.081h473.838c9.986 0 18.081-8.095 18.081-18.081z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 465.673v26.246c0 9.986 8.095 18.081 18.081 18.081h473.838c9.986 0 18.081-8.095 18.081-18.081v-26.246z",
    fill: "url(#SVGID_28_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m255 160.5c-30.879 0-56 25.121-56 56s25.121 56 56 56 56-25.121 56-56-25.121-56-56-56z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 245.5c15.991 0 29-13.009 29-29s-13.009-29-29-29-29 13.009-29 29 13.009 29 29 29z",
    fill: "url(#SVGID_30_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMerryGoRound);
export default __webpack_public_path__ + "static/media/icon-merry-go-round.cb345f6f50ab7fab5f3961a9ec18815c.svg";
export { ForwardRef as ReactComponent };